
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

// extend once so dayjs can parse "DD/MM/YYYY"
dayjs.extend(customParseFormat)

export default {
  // Example expiry date
  validate({ params, redirect }) {
    // 🔒 Hardcoded values for this page
    const FUTURE_DATE = '16/09/2025'   // format: DD/MM/YYYY
    const CODE = params.IPOCode.toLowerCase()  // expected code

    // Date check
    const expiry = dayjs(FUTURE_DATE, 'DD/MM/YYYY', true) // strict parse
    const isExpired =
      !expiry.isValid() || dayjs().isAfter(expiry.endOf('day'))

    // Code + date conditions
    if (CODE !== 'du' || isExpired) {
      // redirect('/')
      // or: return false to trigger 404
      error({ statusCode: 410, message: 'This page is gone' })
      return false
    }

    return true
  },
  // middleware: ['password-protect'],
  fetchOnServer: false,
  data() {
    return {
      expiryDate: '16/09/2025',
      IPOCode: "du",
      subscribeReady: true,
      ipo: null,
      bankLogos: [
        'logos/enbd-logo',
        'logos/adcb-logo_jrc5mk',
        'logos/adib-logo_kvvoju',
        'logos/al-maryah-bank',
        '/logos/dib-logo_vkgiut',
        'logos/emirates-islamic-logo_svbabb',
        'logos/fab-logo_mtezba',
        'logos/wio-bank-logo',
      ],
      video1: {
        videoTitle: 'IPO Subscriptions via DFM App',
        videoId: '787488635',
        videoThumb: 'visuals/dfm-visual-8_g0dosf',
      },
    }
  },
  async fetch() {
    try {
      const response = await fetch(`${this.$config.apiBaseUrl}/data`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `Command=getipodetails&IPOCode=${this.$route.params.IPOCode}`,
      })
      var res = await response.json()
      console.log(res)
      if (res.Body === null) {
        return this.$nuxt.error({ statusCode: 404, message: "This page does not exist" })
      }
      this.ipo = res.Body
    } catch (error) {
      console.log(error)
    }
  },
  computed: {
    lang() {
      if (this.$i18n.locale == 'en') {
        return 'En'
      } else {
        return 'Ar'
      }
    },
    logo() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'LogoURL')[0][`ClaimKeyNote${this.lang}`]
      }
      return ''
    },
    desc() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyDescription')[0][`ClaimKeyInfo${this.lang}`]
      }
      return ''
    },
    IPOShortName() {
      if (this.ipo) {
        return this.ipo[`IPOShortName${this.lang}`]
      }
      return ''
    },
    IPOName() {
      if (this.ipo) {
        return this.ipo[`IPOName${this.lang}`]
      }
      return ''
    },
    website() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'SubscriptionCompanyWebsiteURL')[0][`ClaimKeyNote${this.lang}`]
      }
      return ''
    },
    phone() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyTelephoneNumber')[0].ClaimKeyValue
      }
      return ''
    },
    email() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyEmail')[0].ClaimKeyValue
      }
      return ''
    },
    prospectusURL() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'ProspectusURL')[0][`ClaimKeyNote${this.lang}`]
      }
      return ''
    },
    sharesOffered() {
      return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'SharesOffered')[0].ClaimKeyValue
    },
    priceRange() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'PriceRange')[0].ClaimKeyValue
      }
      return ''
    },
    tradingStartingDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'TradingStartDate')[0].ClaimKeyValue
      }
      return ''
    },
    sector() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'Sector')[0][`ClaimKeyTitle${this.lang}`]
      }
      return ''
    },
    proposedSymbol() {
      if (this.ipo && Array.isArray(this.ipo.Claims) && this.ipo.Claims.length > 0) {
        const claim = this.ipo.Claims.find(c => c?.ClaimKey === 'ProposedSymbol')
        return claim?.ClaimKeyValue || '--'
      }
      return '--'
    },
    companyFullNameClaim() {
      if (this.ipo && Array.isArray(this.ipo.Claims) && this.ipo.Claims.length > 0) {
        const claim = this.ipo.Claims.find(c => c?.ClaimKey === 'CompanyFullName')
        return claim?.ClaimKeyValue || '--'
      }
      return '--'
      // if (this.ipo && this.ipo.Claims.length > 0) {
      //   return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'CompanyFullName')[0][`ClaimKeyTitle${this.lang}`]
      // }
      // return ''
    },
    tradingEndDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'TradingEndDate')[0].ClaimKeyValue
      }
      return ''
    },
    allocationDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'AllocationDate')[0].ClaimKeyValue
      }
      return ''
    },
    refundStartDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'RefundDate')[0].ClaimKeyValue
      }
      return ''
    },
    listingDate() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKey == 'ListingDate')[0].ClaimKeyValue
      }
      return ''
    },
    documents() {
      if (this.ipo && this.ipo.Claims.length > 0) {
        return this.ipo.Claims.filter((claim) => claim.ClaimKeyType == 'Documents')
      }
      return ''
    },
  },
  mounted() {
    // console.log(this.$route.params.IPOCode)
  },
}
